import React from 'react';
import styled from 'styled-components';
import { PageContainer } from '../components/PageContainer';
import { PrimaryFont } from '../components/styles';

const WidthLimit = styled.div`
  max-width: 750px;
`;

const TextBlock = styled(PrimaryFont)`
  display: block;
  text-align: start;
  margin-bottom: 1.5rem;

  font-size: 18px;
  line-height: 28px;
`;

const LetterContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  margin-top: 200px;
  margin-bottom: 300px;
`;

export const PageCovid: React.FC = () => {
  return (
    <PageContainer>
      <LetterContainer>
        <WidthLimit>
          <TextBlock bold>Sponsors and Hackers,</TextBlock>

          <TextBlock>
            Given the increasing developments of the COVID-19 variants, our team has decided to host DubHacks '21 as a
            fully virtual hackathon. As excited as we are for the return to in-person hacking, our top priority is to
            protect the health, safety, and well-being of our hackers and the larger University of Washington community
            during these times.
          </TextBlock>

          <TextBlock>
            Fortunately, we learned a lot from hosting over 1,500 hackers virtually for DubHacks'20. Our team is working
            hard alongside our amazing sponsors to provide exciting and meaningful ways for our community to connect
            over the weekend. We hope that DubHacks '21 will be a safe and welcoming environment for you to learn,
            build, and better understand the ways technology can support communities at large, particularly amidst this
            pandemic.
          </TextBlock>

          <TextBlock>
            Please continue to practice social distancing, stay masked, and get vaccinated if you are able.
          </TextBlock>

          <TextBlock>
            We appreciate your understanding and we're looking forward to reconnecting with you soon.
          </TextBlock>

          <TextBlock>
            With &lt;3, <br />
            <PrimaryFont bold>The DubHacks Team</PrimaryFont>
          </TextBlock>
        </WidthLimit>
      </LetterContainer>
    </PageContainer>
  );
};
